// Smart Sash Admin Panel - Group Service
// CRUD operations for group management (v2 API)

import { axiosClient } from '../http/axiosClient';
import {
  GroupDTO,
  CreateGroupRequest,
  UpdateGroupRequest,
  PaginatedResponse,
  PaginationParams,
  ApiPaginatedData,
  toPaginatedResponse,
} from '@/models';

const BASE_PATH = '/Group';

/**
 * Group Service (v2)
 */
export const groupService = {
  /**
   * Get all groups with pagination
   */
  getAll: async (params?: PaginationParams): Promise<PaginatedResponse<GroupDTO>> => {
    const response = await axiosClient.get<ApiPaginatedData<GroupDTO>>(BASE_PATH, {
      params,
    });
    return toPaginatedResponse(response.data);
  },

  /**
   * Get group by ID
   */
  getById: async (id: string): Promise<GroupDTO> => {
    const response = await axiosClient.get<GroupDTO>(`${BASE_PATH}/${id}`);
    return response.data;
  },

  /**
   * Create new group
   */
  create: async (data: CreateGroupRequest): Promise<GroupDTO> => {
    const response = await axiosClient.post<GroupDTO>(BASE_PATH, data);
    return response.data;
  },

  /**
   * Update existing group
   */
  update: async (id: string, data: UpdateGroupRequest): Promise<GroupDTO> => {
    const response = await axiosClient.put<GroupDTO>(`${BASE_PATH}/${id}`, data);
    return response.data;
  },

  /**
   * Delete group
   */
  delete: async (id: string): Promise<void> => {
    await axiosClient.delete(`${BASE_PATH}/${id}`);
  },
};

export default groupService;
